import { useState } from 'react';
import { useHydroStore } from '../../hooks/useHydroStore';
import WatershedPanel from './WatershedPanel';
import PeakFlowPanel from './PeakFlowPanel';
import PrecipPanel from './PrecipPanel';
import TechnicalDetails from '../TechnicalDetails';

export default function Sidebar() {
  const { selectedPoint, analysisResult, isLoading, error, clearAnalysis } =
    useHydroStore();
  const [showTechDetails, setShowTechDetails] = useState(false);

  return (
    <aside className="sidebar">
      <header className="sidebar-header">
        <h1>Hydro-NM</h1>
        <p>New Mexico Hydrology & Drainage</p>
        <button
          className="info-button"
          onClick={() => setShowTechDetails(true)}
          title="Technical Documentation"
        >
          ?
        </button>
      </header>

      <TechnicalDetails
        isOpen={showTechDetails}
        onClose={() => setShowTechDetails(false)}
      />

      <div className="sidebar-content">
        {!selectedPoint && !isLoading && (
          <div className="instruction-box">
            <p>Click anywhere on the map within New Mexico to analyze hydrology at that location.</p>
          </div>
        )}

        {selectedPoint && (
          <div className="panel">
            <div className="panel-title">Selected Location</div>
            <div className="coords-display">
              {selectedPoint.lat.toFixed(6)}°N, {Math.abs(selectedPoint.lng).toFixed(6)}°W
            </div>
            <button
              className="btn btn-secondary"
              onClick={clearAnalysis}
              style={{ marginTop: '0.75rem', width: '100%' }}
            >
              Clear Selection
            </button>
          </div>
        )}

        {isLoading && (
          <div className="panel">
            <div className="loading-spinner">
              <div className="spinner" />
            </div>
            <p style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
              Analyzing watershed...
            </p>
          </div>
        )}

        {error && (
          <div className="panel" style={{ background: '#fef2f2' }}>
            <div className="panel-title" style={{ color: 'var(--error)' }}>
              Error
            </div>
            <p style={{ color: 'var(--error)', fontSize: '0.875rem' }}>{error}</p>
          </div>
        )}

        {analysisResult && !isLoading && (
          <>
            <WatershedPanel watershed={analysisResult.watershed} />
            <PeakFlowPanel peakFlows={analysisResult.peak_flows} />
            <PrecipPanel precipData={analysisResult.precip_frequency} />
          </>
        )}
      </div>
    </aside>
  );
}
